// extracted by mini-css-extract-plugin
module.exports = {"feed-slider-root":"FeedSlider_feed-slider-root__26N6z","content":"FeedSlider_content__Qvfwc","bullet":"FeedSlider_bullet__2EGfm","bullet_active":"FeedSlider_bullet_active__qhGlw"};